import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import PlayerInvite from './player-invite-model'
import {
  CreatePlayerInviteAsync,
  DeletePlayerInviteAsync,
  LoadPlayerInvitesAsync,
} from './playerInvite-thunk'
const initialState: playerInviteSliceState = {
  playerInvite: [],
  selected_playerInvite: '',
  is_loading_playerInvite: false,
  is_creating_playerInvite: false,
  is_deleting_playerInvite: false,
}
export interface playerInviteSliceState {
  playerInvite: PlayerInvite[]
  selected_playerInvite?: string
  is_loading_playerInvite: boolean
  is_creating_playerInvite: boolean
  is_deleting_playerInvite: boolean
}
export const playerInviteSlice = createSlice({
  name: 'playerInvite',
  initialState,
  reducers: {
    setSelectedplayerInvite: (state, action) => {
      state.selected_playerInvite = action.payload
    },
    clearStateplayerInvite: (state) => {
      state.playerInvite = []
      state.is_loading_playerInvite = false
      state.is_creating_playerInvite = false
      state.is_deleting_playerInvite = false
    },
    mergeplayerInvite: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_playerInvite = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.playerInvite = merge(state.playerInvite, payload) as any
        }
      }
    },

    add_playerInvite: (state, action) => {
      if (action.payload) {
        state.playerInvite = [...state.playerInvite, action.payload]
      }
    },
    set_playerInvite: (state, action) => {
      let { key, value, id } = action.payload
      state.playerInvite = state.playerInvite.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPlayerInvitesAsync.pending, (state) => {
      state.is_loading_playerInvite = true
    })
    builder.addCase(LoadPlayerInvitesAsync.fulfilled, (state, action) => {
      state.is_loading_playerInvite = false
      if (action.payload) {
        state.playerInvite = action.payload
      }
    })
    builder.addCase(LoadPlayerInvitesAsync.rejected, (state) => {
      state.is_loading_playerInvite = false
    })
    builder.addCase(CreatePlayerInviteAsync.pending, (state) => {
      state.is_creating_playerInvite = true
    })
    builder.addCase(CreatePlayerInviteAsync.fulfilled, (state) => {
      state.is_creating_playerInvite = false
    })
    builder.addCase(CreatePlayerInviteAsync.rejected, (state) => {
      state.is_creating_playerInvite = false
    })
    builder.addCase(DeletePlayerInviteAsync.pending, (state) => {
      state.is_deleting_playerInvite = true
    })
    builder.addCase(DeletePlayerInviteAsync.fulfilled, (state, action) => {
      state.is_deleting_playerInvite = false
      if (state.playerInvite) {
        state.playerInvite = state.playerInvite.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeletePlayerInviteAsync.rejected, (state) => {
      state.is_deleting_playerInvite = false
    })

    builder.addCase(autoThunks.accept_player_invite.pending, (state) => {
      state.is_loading_playerInvite = true
    })
    builder.addCase(
      autoThunks.accept_player_invite.fulfilled,
      (state, action) => {
        state.is_loading_playerInvite = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.accept_player_invite.rejected, (state) => {
      state.is_loading_playerInvite = false
    })

    builder.addCase(autoThunks.get_player_invites.pending, (state) => {
      state.is_loading_playerInvite = true
    })
    builder.addCase(
      autoThunks.get_player_invites.fulfilled,
      (state, action) => {
        state.is_loading_playerInvite = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_player_invites.rejected, (state) => {
      state.is_loading_playerInvite = false
    })

    builder.addCase(autoThunks.invite_player_to_playwatch.pending, (state) => {
      state.is_loading_playerInvite = true
    })
    builder.addCase(
      autoThunks.invite_player_to_playwatch.fulfilled,
      (state, action) => {
        state.is_loading_playerInvite = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.invite_player_to_playwatch.rejected, (state) => {
      state.is_loading_playerInvite = false
    })
  },
})

function handleResult(action: any, state: playerInviteSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_playerInvite = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.playerInvite = merge(state.playerInvite, payload) as any
    }
  }
}

export const {
  clearStateplayerInvite,
  setSelectedplayerInvite,
  set_playerInvite,
  mergeplayerInvite,
  add_playerInvite,
} = playerInviteSlice.actions

export const get_playerInvite =
  (id?: string) =>
  (state: {
    playerInvite: {
      playerInvite: PlayerInvite[]
    }
  }): PlayerInvite | null => {
    let temp = state?.playerInvite?.playerInvite?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.playerInvite?.playerInvite[0] || null
  }
export const get_selected_playerInvite = (state: {
  playerInvite: playerInviteSliceState
}): PlayerInvite | null => {
  let id = state?.playerInvite?.selected_playerInvite
  let temp = state?.playerInvite?.playerInvite?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_playerInvite = (state: {
  playerInvite: {
    playerInvite: PlayerInvite[]
  }
}): PlayerInvite[] => {
  let temp = state?.playerInvite?.playerInvite
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_playerInvite_busy = (state: {
  playerInvite: playerInviteSliceState
}) => {
  return (
    state?.playerInvite.is_deleting_playerInvite ||
    state?.playerInvite.is_loading_playerInvite ||
    state?.playerInvite.is_creating_playerInvite
  )
}
export const is_deleting_playerInvite_busy = (state: {
  playerInvite: playerInviteSliceState
}) => {
  return state?.playerInvite.is_deleting_playerInvite
}
export const is_loading_playerInvite_busy = (state: {
  playerInvite: playerInviteSliceState
}) => {
  return state?.playerInvite.is_loading_playerInvite
}
export const is_creating_playerInvite_busy = (state: {
  playerInvite: playerInviteSliceState
}) => {
  return state?.playerInvite.is_creating_playerInvite
}

export default playerInviteSlice.reducer
